module.exports = __webpack_public_path__ + "img/insta360.f7ffca5b.webp";